import Top from "../components/ContactPage/Top.js"
import Middle from "../components/ContactPage/Middle.js"
import Bottom from "../components/ContactPage/Bottom.js"


export default function Main() {
  return (
    <>
      <Top />
      <Middle />
      <Bottom />
    </>
  );
}